import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import InfoIcon from '@mui/icons-material/Info';

const NotificationDialog = ({ open, onClose, notification }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  if (!notification) return null;

  // Determine notification style based on type
  const getNotificationConfig = () => {
    switch (notification.type) {
      case 'success':
        return {
          icon: <CheckCircleIcon sx={{ fontSize: '3rem', color: '#4caf50' }} />,
          bgColor: '#e8f5e9',
          borderColor: '#4caf50',
          title: 'Sukces!',
        };
      case 'error':
        return {
          icon: <ErrorIcon sx={{ fontSize: '3rem', color: '#f44336' }} />,
          bgColor: '#ffebee',
          borderColor: '#f44336',
          title: 'Błąd',
        };
      case 'info':
        return {
          icon: <InfoIcon sx={{ fontSize: '3rem', color: '#2196f3' }} />,
          bgColor: '#e3f2fd',
          borderColor: '#2196f3',
          title: 'Informacja',
        };
      case 'warning':
        return {
          icon: <ErrorIcon sx={{ fontSize: '3rem', color: '#ff9800' }} />,
          bgColor: '#fff3e0',
          borderColor: '#ff9800',
          title: 'Uwaga',
        };
      default:
        return {
          icon: <InfoIcon sx={{ fontSize: '3rem', color: '#2196f3' }} />,
          bgColor: '#e3f2fd',
          borderColor: '#2196f3',
          title: 'Informacja',
        };
    }
  };

  const config = getNotificationConfig();

  return (
    <Dialog 
      open={open} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          m: isMobile ? 2 : 3,
        }
      }}
    >
      <DialogContent sx={{ pt: 4, pb: 3, px: 3 }}>
        <Stack spacing={3} alignItems="center">
          {/* Icon */}
          <Box>{config.icon}</Box>
          
          {/* Title */}
          <Typography 
            variant={isMobile ? "h6" : "h5"} 
            fontWeight="600" 
            textAlign="center"
          >
            {config.title}
          </Typography>
          
          {/* Message Card */}
          <Box
            sx={{
              width: '100%',
              backgroundColor: config.bgColor,
              border: `2px solid ${config.borderColor}`,
              borderRadius: 2,
              p: 2.5,
            }}
          >
            <Typography 
              variant="body1" 
              textAlign="center"
              sx={{ 
                color: 'text.primary',
                fontWeight: 500,
              }}
            >
              {notification.message}
            </Typography>
          </Box>
        </Stack>
      </DialogContent>
      
      <DialogActions sx={{ 
        px: 3, 
        pb: 3,
        justifyContent: 'center',
      }}>
        <Button
          onClick={onClose}
          variant="contained"
          color="primary"
          size="large"
          sx={{ 
            minWidth: 120,
            minHeight: 44,
            borderRadius: 2,
          }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotificationDialog;
